module.exports = __webpack_public_path__ + "img/m-bg4.5b497b73.jpg";